import styled from 'styled-components';

export const Container = styled.label`
  margin: 0;
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div<{
  $checked: boolean;
  $type: 'square' | 'round';
  $size: string;
  $backgroundColor?: string;
  $border?: string;
  $borderColorCheckedSquare?: string;
  $borderRadius?: string;
  $focusBorder?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.$size};
  height: ${props => props.$size};

  ${props => {
    if (props.$border) return `border:${props.$border};`;
    else if (!props.$checked && props.$type === 'round')
      return `border:0.2rem solid ${props.theme.color.greyMediumDark};`;

    if (props.$type === 'square')
      return `border:0.2rem solid ${
        props.$checked && props.$borderColorCheckedSquare
          ? props.$borderColorCheckedSquare
          : props.theme.color.greyDark
      };`;
  }};
  color: ${props => {
    if (props.$checked && props.$type === 'round')
      return props.theme.color.primary;
    return props.theme.color.greyDark;
  }};

  border-radius: ${props => props.$type === 'round' && '3rem'};
  border-radius: ${props => props.$borderRadius};
  transition: all 150ms;
  background-color: ${props => props.$backgroundColor};
  background: ${props => {
    if (props.$checked && props.$type === 'round') {
      if (props.$backgroundColor) return props.$backgroundColor;
      return props.theme.color.primary;
    }
    if (!props.$checked && props.$type === 'round') {
      return props.theme.color.white;
    }
  }};
  ${HiddenCheckbox}:focus + & {
    border: ${props =>
      props.$focusBorder ?? `0.2rem solid ${props.theme.color.primary}`};
    outline: none;
  }
`;

export const CheckboxWrapper = styled.div<{
  $alignItems?: string;
  $gap: string;
  $padding?: string;
}>`
  gap: ${({ $gap }) => $gap};
  align-items: ${({ $alignItems }) => $alignItems ?? 'center'};
  display: flex;
  flex-direction: row;
  padding: ${({ $padding }) => $padding};
`;

export const Bullet = styled.span<{ $size: string }>`
  transform: scale(3);
  color: ${({ theme }) => theme.color.mobilityGrey3};
  position: relative;
  bottom: 0.3rem;
`;
